import { Injectable } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { requestList, WSService } from 'projects/core/src/include/service';
import { Observable } from 'rxjs';
import { Dossier } from '../dossier';
import { Filter, Ordering, FilterAdvanced } from 'projects/core/src/include/structures';

@Injectable({
  providedIn: 'root'
})
export class DossierService extends WSService<Dossier> {

  constructor() { super("dossier");}


  

  setPhase(id_dossier: number,id_phase: number,state: number,note: string):Observable<any>{
    return Globals.ws.requestUrl("dossier","setPhase",[id_dossier,id_phase,state,note]);
  }

  getLog(id_dossier: number):Observable<any>{
    return Globals.ws.requestUrl("dossier","getLog",[id_dossier]);
    
  }

  setDossierRead(id_dossier: number):Observable<any>{
    return Globals.ws.requestUrl("dossier","setDossierRead",[id_dossier]);
  }

  checkDuplicate(id_dossier: number,code:string):Observable<any>{
    return Globals.ws.requestUrl("dossier","checkDuplicate",[id_dossier,code]);
  }

  updateLog(log:any,returnid:Function){

    var item2db:any=log;
    if(Globals.ws.api_version=="v2")
      item2db={"values":log}

     Globals.ws.send("dossier","updateLog",item2db,[],(result:any)=>{returnid(result);});

  }

}
